import _Button from "@kibt/meta-ui/es/button";
import { defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api';
export default defineComponent({
  components: {
    MetaButton: _Button
  },
  props: {
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    // 滑动时消失，静止时展示
    scrollHide: {
      type: Boolean,
      default: false
    }
  },
  emits: ['btn-click'],
  setup: function setup(props, ctx) {
    var handleBtnClick = function handleBtnClick(e) {
      // meta-ui的bug
      if (!props.disabled) {
        ctx.emit('btn-click');
      }
    };

    var footerShow = ref(true);
    var timer = null;

    var handleScrollHide = function handleScrollHide() {
      if (props.scrollHide) {
        footerShow.value = false;
      }

      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        footerShow.value = true;
      }, 1000);
    };

    onMounted(function () {
      window.addEventListener('scroll', handleScrollHide);
    });
    onUnmounted(function () {
      window.removeEventListener('scroll', handleScrollHide);
    });
    return {
      handleBtnClick: handleBtnClick,
      footerShow: footerShow
    };
  }
});